export default __webpack_public_path__ + "static/media/antp_ingvehicular_Abimael.7b59c4e0.jpg";